import _ from 'lodash';
import {
  INTENT_TYPES, SL_TRAIL_TYPES, STOPS_VALUE_TYPES
} from 'v2/common/constants/index';
import { defaultLinearTrail } from 'v2/modules/withRunForm/configs/index';

const AUTO_TRANSACTION_TSL_PIPE_NAME = 'AUTO_TRANSACTION_TSL_PIPE_NAME';

const autoTransactionTSLPipeConfig = (slType, slValue, trail, caseIndex) => ({
  type: 'transactionStopLoss',
  name: `${AUTO_TRANSACTION_TSL_PIPE_NAME}_CASE_${caseIndex}`,
  uiConfigs: { isAutoPipe: true },
  config: {
    caseIndex,
    stopLoss: {
      type: slType,
      value: slValue,
      trail
    }
  }
});

const autoTSLAdjustment = (kaseIndex) => ({
  uiConfigs: {
    isAutoAdjustment: true,
    adjustmentMode: 'transactionTSL',
  },
  signal: [{
    conditionOperator: '',
    leftOperand: `${AUTO_TRANSACTION_TSL_PIPE_NAME}_CASE_${kaseIndex}`,
    operator: 'equalTo',
    rightOperand: '1',
  }],
  intents: [{ type: INTENT_TYPES.ExitTransaction }]
});

export const addOverallTransactionTSL = (quantConfig) => {
  const {
    value: slValue,
    type: slType,
    uiConfigs = {}
  } = quantConfig?.bounds?.stopLoss || {};
  const isValidSlType = _.values(STOPS_VALUE_TYPES).includes(slType);
  if (!slValue || !isValidSlType) {
    return quantConfig;
  }

  const { trail = {} } = uiConfigs;
  const isValidTrail = _.values(SL_TRAIL_TYPES).includes(trail.type);
  if (_.isEmpty(trail) || _.isEqual(defaultLinearTrail) || !isValidTrail) {
    return quantConfig;
  }

  const updatedCases = [];
  const syntheticTSLPipeConfig = [];

  quantConfig.cases.forEach((kase, kaseIndex) => {
    updatedCases.push({
      ...kase,
      adjustments: [...kase.adjustments, autoTSLAdjustment(kaseIndex)]
    });

    syntheticTSLPipeConfig.push(autoTransactionTSLPipeConfig(slType, slValue, trail, kaseIndex));
  });

  const newQuantConfig = {
    ...quantConfig,
    pipeConfigs: [...quantConfig.pipeConfigs, ...syntheticTSLPipeConfig],
    cases: updatedCases
  };

  return newQuantConfig;
};
